import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DOB_INPUT_DATE } from "@jti/fe-common";
import { getExtraProfileDataFromCustomAttributes } from "../getExtraProfileDataFromCustomAttributes";
const parseDateToISOString = (date) => {
    dayjs.extend(customParseFormat);
    return dayjs(date, DOB_INPUT_DATE).format();
};
export const prepareUserProfileEvo = (profileData, meta) => {
    return {
        is_age_verified: meta.is_age_verified,
        is_pending_email_verification: profileData.is_pending_email_verification,
        personalInfo: {
            email: profileData.consumer.email,
            firstname: profileData.consumer.first_name,
            lastname: profileData.consumer.last_name,
            dob: profileData.consumer.date_of_birth,
            telephone: profileData.consumer.phone,
            gender: profileData.consumer.gender,
        },
        addresses: profileData.consumer.addresses,
        extra: getExtraProfileDataFromCustomAttributes(profileData.consumer.custom_attributes),
        purposes: profileData.purposes,
        meta: meta,
    };
};
export const prepareUserProfile = (userProfileResponse) => {
    const { is_age_verified, is_pending_email_verification, personal_info: { email, firstname, lastname, date_of_birth: dob, phone: telephone, gender }, addresses, extra, purposes, meta, } = userProfileResponse;
    return {
        is_age_verified,
        is_pending_email_verification,
        personalInfo: {
            email,
            firstname,
            lastname,
            dob: dob && parseDateToISOString(dob),
            telephone,
            gender,
        },
        addresses,
        extra,
        purposes,
        meta,
    };
};
//# sourceMappingURL=prepareProfileData.js.map